<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>活动触发条件</span>
          <syncVersion :in-method="actRuleCondSyncOss" />
          <clear-cache-apply />
          <sync-data />
        </div>

        <el-table :data="formData" border stripe>
          <el-table-column prop="price" label="事件">
            <template v-slot:default="scope">
              <el-select v-model.number="scope.row.event_id" placeholder="请选择" @change="listenSelectType">
                <el-option
                  v-for="item in event"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  :disabled="item.disabled"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="x" label="数值X">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.x" placeholder="数值X" />
            </template>
          </el-table-column>
          <el-table-column prop="y" label="数值Y">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.y" placeholder="数值Y" />
            </template>
          </el-table-column>
          <el-table-column prop="z" label="数值Z">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.z" placeholder="数值Z" />
            </template>
          </el-table-column>
          <el-table-column prop="z" label="持续时间(分钟)">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.num" placeholder="持续时间" />
            </template>
          </el-table-column>
          <el-table-column prop="trigger_count" label="触发限定次数">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.trigger_count" placeholder="触发限定次数" />
            </template>
          </el-table-column>
          <el-table-column prop="trigger_interval" label="触发间隔">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.trigger_interval" placeholder="触发间隔" />
            </template>
          </el-table-column>
          <el-table-column prop="v" label="权重">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.v" placeholder="权重" />
            </template>
          </el-table-column>
          <el-table-column prop="price" label="触发生效活动类型">
            <template v-slot:default="scope">
              <el-select v-model="scope.row.atype" multiple placeholder="请选择">
                <el-option
                  v-for="item in types"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>
          </el-table-column>
          <!--          <el-table-column prop="price" label="触发生效活动">-->
          <!--            <template v-slot:default="scope">-->
          <!--              <el-select v-model="scope.row.aid" multiple placeholder="请选择">-->
          <!--                <el-option-->
          <!--                  v-for="item in gift"-->
          <!--                  :key="item.value"-->
          <!--                  :label="item.name"-->
          <!--                  :value="item.id"-->
          <!--                />-->
          <!--              </el-select>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column label="操作">
            <template v-slot:default="scope">
              <el-button v-permisaction="['config:ruleActCond:del']" type="danger" size="mini" @click="del(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button v-permisaction="['config:ruleActCond:add']" type="primary" style="margin-top: 10px" @click="add()">+</el-button>
        <el-button v-permisaction="['config:ruleActCond:add']" type="primary" style="margin-top: 10px" @click="onSubmit()">保存</el-button>
        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>

    </template>
  </BasicLayout>
</template>

<script>
import { getGiftCond } from '@/api/config/active-skin-cfg'
import {
  actRuleCondSyncOss,
  delActivityRuleCondCfg,
  getActivityAllList,
  getActivityRuleCondCfg,
  getActivityTypesList,
  updateActivityRuleCondCfg
} from '@/api/config/activity-cfg'
import SyncVersion from '@/components/SyncVersion/index.vue'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'
export default {
  name: 'RuleActCond',
  components: { SyncData, ClearCacheApply, SyncVersion },
  data() {
    return {
      event: [],
      gift: [],
      giftGroup: [],
      rewardType: [],
      total: 0,
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        type: this.gType
      },
      types: [],
      formData: [
        {
          id: 0,
          event_id: '',
          x: 0,
          y: 0,
          z: 0,
          num: 0,
          trigger_count: 0,
          trigger_interval: 0,
          v: 0,
          gift_group: [],
          gift: []
        }
      ]
    }
  },
  created() {
    this.getActivityTypes()
    this.getShopGiftList()
    this.getGiftCondList()
    this.getTables()
  },
  methods: {
    actRuleCondSyncOss,
    onSubmit() {
      for (const i in this.formData) {
        const val = this.formData[i]
        if (!val.event_id) {
          this.msgError('请选择事件ID')
          return
        }
      }
      const data = JSON.stringify(this.formData)
      updateActivityRuleCondCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getActivityRuleCondCfg(this.queryParams).then(res => {
        if (res.code === 200) {
          this.formData = res.data.list
          this.total = res.data.count
          this.listenSelectType()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      this.listenSelectType()
      let selectType = ''
      for (const i in this.event) {
        const val = this.event[i]
        if (!val.disabled) {
          selectType = val.value
          break
        }
      }

      if (!selectType) {
        this.msgError('无可选类型')
        return
      }
      this.formData.push({
        event_id: selectType,
        x: 0,
        y: 0,
        z: 0,
        num: 0,
        trigger_count: 0,
        trigger_interval: 0,
        v: 0,
        atype: [],
        aid: []
      })
    },
    listenSelectType() {
      // for (const k in this.event) {
      //   const event = this.event[k]
      //   this.event[k].disabled = false
      //   for (const i in this.formData) {
      //     const val = this.formData[i]
      //     if (val.event_id === event.value) {
      //       this.event[k].disabled = true
      //     }
      //   }
      // }
    },
    del(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delActivityRuleCondCfg({ id: id }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    getGiftCondList() {
      getGiftCond().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            const val = res.data[i]
            this.event.push({ label: val, value: parseInt(i), disabled: false })
          }
        }
      })
    },
    getActivityTypes() {
      getActivityTypesList().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            const val = res.data[i]
            this.types.push({ label: val, value: i })
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getShopGiftList() {
      getActivityAllList().then(res => {
        if (res.code === 200) {
          this.gift = res.data
        }
      })
    }
    // uploadCdn() {
    //   this.$confirm('此操作将同步到S3, 是否继续?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     actRuleCondSyncOss().then(res => {
    //       if (res.code === 200) {
    //         this.msgSuccess(res.msg)
    //         this.getTables()
    //       } else {
    //         this.msgError(res.msg)
    //       }
    //     })
    //   })
    // }
  }
}
</script>

<style scoped>
</style>
